export default __webpack_public_path__ + "static/media/cerba.ce55afd2.png";